import { groq } from 'next-sanity'
import { flexibleContent, seoFields } from '@otomoro/sanity/lib/queries/partials/shared'

export const companyPageQuery = groq`*[_type == "companyPage" && language == "en"][0] {
	pageTitle,
	headline,
  subHeadline,
	introduction,
	${flexibleContent}
	${seoFields}
}`

export const companyPageSeoQuery = groq`*[_type == "companyPage" && language == "en"][0]{
  ${seoFields}
}`
